import { Injectable } from '@angular/core';
import { RouterStateSnapshot, CanActivate } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { RoutingService } from '@app/core/services/routing.service';

@Injectable()
export class VoucherGuard implements CanActivate {
  constructor(private routingService: RoutingService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // Download Voucher
    if (
      route.queryParams['g'] &&
      route.queryParams['page'] &&
      route.queryParams['produit'] &&
      route.queryParams['token']
    ) {
      this.routingService.failover(state.url);

      return false;
    }
    return true;
  }
}
